import { render, staticRenderFns } from "./ProdesResiduosMataAtlantica.vue?vue&type=template&id=750b9f15&lang=pug"
import script from "./ProdesResiduosMataAtlantica.vue?vue&type=script&lang=js"
export * from "./ProdesResiduosMataAtlantica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports